import React, { useState, useEffect } from "react";
import useStyles from "./ContactForm.styles";

export default function ContactForm() {
  const [inputs, setInputs] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    message: "",
  });
  const classes = useStyles();
  useEffect(() => {}, []);

  function handlechange(e: any) {
    const { name, value } = e.target;
    setInputs({ ...inputs, [name]: value });
  }

  return (
    <div className={classes.contactBg}>
      <div className={classes.contactContainer}>
        <h3 className={classes.contactHeader}>contact me</h3>
        <p>for project, and consultation you can contact me.</p>
        <span></span>

        <form name="contact-form" method="POST" data-netlify="true">
          <input type="hidden" name="form-name" value="contact-form" />

          <div>
            <input
              name="name"
              value={inputs.name}
              onChange={handlechange}
              className={classes.input}
              placeholder="enter your name"
              required
            />
          </div>

          <div>
            <input
              name="email"
              value={inputs.email}
              onChange={handlechange}
              className={classes.input}
              placeholder="enter your email"
              required
            />
          </div>

          <div>
            <input
              name="phoneNumber"
              value={inputs.phoneNumber}
              onChange={handlechange}
              className={classes.input}
              placeholder="enter your phone number"
              required
            />
          </div>

          <div>
            <textarea
              name="message"
              value={inputs.message}
              onChange={handlechange}
              className={classes.textarea}
              placeholder="your message"
              required
            />
          </div>

          <button className={classes.contactBtn}>submit</button>
        </form>
      </div>
    </div>
  );
}
